module.exports = __webpack_public_path__ + "img/language.a90e34fc.svg";